
import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import ListItem from '@material-ui/core/ListItem'

import StyledPaper from '../StyledPaper'

const styles = theme => ({
  fullWidth: {width: '100%'},
  noPadding: {padding: 0},
  // FormControlLabel Overrides ( allows the label to fill entire Paper )
  formControlLabelRoot: {
    marginLeft: 0,
    marginRight: 0,
    padding: theme.spacing.unit * 2
  }
})

const Material = ({ checked, classes, href, onCheckboxClick, onLabelClick, sessionComplete, text }) => (
  <ListItem disableGutters>
    <StyledPaper className={`${classes.fullWidth} ${classes.noPadding}`}>
      {href !== "" ? (
        <FormControlLabel
          classes={{root: classes.formControlLabelRoot}}
          className={`${classes.fullWidth}`}
          control={
            <Checkbox
              checked={checked}
              disabled={sessionComplete}
              label={text}
              onClick={onCheckboxClick}
              value={text}
            />
          }
          label={<label><a onClick={onLabelClick} href={href} target="_blank">{text}</a></label>}
          style={styles.fullWidth}
        />
      ) : (
        <FormControlLabel
          classes={{root: classes.formControlLabelRoot}}
          className={`${classes.fullWidth}`}
          control={
            <Checkbox
              checked={checked}
              disabled={sessionComplete}
              label={text}
              onClick={onCheckboxClick}
              value={text}
            />
          }
          label={text}
          style={styles.fullWidth}
        />
      )}
    </StyledPaper>
  </ListItem>
)

Material.propTypes = {
  checked: PropTypes.bool.isRequired,
  href: PropTypes.string.isRequired,
  onCheckboxClick: PropTypes.func.isRequired,
  onLabelClick: PropTypes.func.isRequired,
  sessionComplete: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
}

export default withStyles(styles)(Material)


// WEBPACK FOOTER //
// ./src/components/counseling-session/educational-materials/Material.js